import { createFileRoute } from "@tanstack/react-router";

import { AdminRegisterPage } from "@/features/admin/admin-register-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/admin-register")({
  staticData: { crumb: { label: STATIC_LABELS.adminAdminRegister } },
  component: AdminRegisterPage,
});
